import $ from 'jquery';
import { fabric } from 'fabric';
import {
  updateBoundaryPosition,
  enforceMinimumAndMaximumSize,
} from '~core/expand';
import { getState, modifyState } from '~src/state';
import isMobile from 'is-mobile';

export default function createBoundaryRect(canvas, img) {
  if (!img) return;

  let originalImage = img;

  // Get image dimensions and position
  const imgWidth = img.width * img.scaleX;
  const imgHeight = img.height * img.scaleY;
  const imgLeft = img.left;
  const imgTop = img.top;

  // Remove previous boundary if exists
  // if (boundaryRect) {
  //   canvas.remove(boundaryRect);
  // }

  // Create a rectangle around the image

  const borderWidth = 2;

  let cornerSizeValue = 60;
  let borderScaleFactorValue = 6;

  if (isMobile()) {
    if (window.expandDrawingCanvas.width > window.expandDrawingCanvas.height) {
      cornerSizeValue = window.expandDrawingCanvas.width / 40;
      borderScaleFactorValue = window.expandDrawingCanvas.width / 300;
    } else {
      cornerSizeValue = window.expandDrawingCanvas.height / 40;
    }
  } else {
    if (window.expandDrawingCanvas.width > window.expandDrawingCanvas.height) {
      cornerSizeValue = window.expandDrawingCanvas.width / 80;
      borderScaleFactorValue = window.expandDrawingCanvas.width / 550;
    } else {
      cornerSizeValue = window.expandDrawingCanvas.height / 80;
    }
  }

  const boundaryRect = new fabric.Rect({
    id: 'boundary-rect',
    left: imgLeft,
    top: imgTop,
    width: imgWidth,
    height: imgHeight,
    fill: 'transparent',
    stroke: 'blue',
    strokeDashArray: [5, 5],
    strokeWidth: borderWidth,
    selectable: true,
    hasControls: true,
    hasBorders: false,
    lockRotation: true,
    lockScalingFlip: true,
    padding: 0,
    borderScaleFactor: borderScaleFactorValue,
    cornerSize: cornerSizeValue, // pallini
    // Store original image dimensions for minimum size enforcement
    imgData: {
      originalImgLeft: imgLeft,
      originalImgTop: imgTop,
      originalImgWidth: imgWidth,
      originalImgHeight: imgHeight,
    },
  });

  // Add to canvas and set as active object
  // canvas.add(boundaryRect);
  // canvas.setActiveObject(boundaryRect);
  // canvas.renderAll();

  // Enable outpainting mode
  // isOutpaintingMode = true;
  // applyBtn.classList.remove('disabled');

  boundaryRect.on('moving', function () {
    if (!originalImage) return;
    updateBoundaryPosition(canvas, boundaryRect, originalImage);
    const expandCoordinates = getState('expandCoordinates');

    modifyState('expandCoordinates', {
      ...expandCoordinates,
      newSize: [
        boundaryRect.width * boundaryRect.scaleX,
        boundaryRect.height * boundaryRect.scaleY,
      ],
      imagePosition: [imgLeft - boundaryRect.left, imgTop - boundaryRect.top],
    });

    const isSizeChanged =
      expandCoordinates.newSize[0] !== expandCoordinates.originalSize[0] ||
      expandCoordinates.newSize[1] !== expandCoordinates.originalSize[1];

    if (isSizeChanged) {
      $('#editor-menu-exec-ai-expand').prop('disabled', false);
    } else {
      $('#editor-menu-exec-ai-expand').prop('disabled', true);
    }
  });

  boundaryRect.on('scaling', function () {
    if (!originalImage) return;
    enforceMinimumAndMaximumSize(canvas, boundaryRect, originalImage);
    const expandCoordinates = getState('expandCoordinates');

    modifyState('expandCoordinates', {
      ...expandCoordinates,
      newSize: [
        boundaryRect.width * boundaryRect.scaleX,
        boundaryRect.height * boundaryRect.scaleY,
      ],
      imagePosition: [imgLeft - boundaryRect.left, imgTop - boundaryRect.top],
    });

    const isSizeChanged =
      expandCoordinates.newSize[0] !== expandCoordinates.originalSize[0] ||
      expandCoordinates.newSize[1] !== expandCoordinates.originalSize[1];

    if (isSizeChanged) {
      $('#editor-menu-exec-ai-expand').prop('disabled', false);
    } else {
      $('#editor-menu-exec-ai-expand').prop('disabled', true);
    }
  });

  updateBoundaryPosition(canvas, boundaryRect, originalImage);

  return boundaryRect;
}
